export enum ReplacementRequestStatus {
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED',
  EXPIRED = 'EXPIRED',
  // CANCELED is persisted by `cancelGameAsAdmin` (cancel-game-as-admin.ts) when an
  // admin cancels a game that has a PENDING replacement request — the RR is flipped
  // to CANCELED. `cancelReplacementRequest` (the user-facing path) always throws
  // GoneException, so CANCELED is only reachable via the admin path.
  // The mobile hub renders a dedicated "Link cancelled" variant for this state.
  // Do not remove without coordinating a migration to update the DB check constraint
  // and removing the UI branches (#stress-test #4, #13).
  CANCELED = 'CANCELED',
}

export enum ReplacementRequestType {
  FULL_CANCEL = 'FULL_CANCEL',
  PARTICIPANT_LEFT = 'PARTICIPANT_LEFT',
}

export class CreateReplacementRequestDto {
  type: ReplacementRequestType;
}

export class ReplacementRequestDto {
  token: string;
  gameId: number;
  type: ReplacementRequestType;
  status: ReplacementRequestStatus;
  courtId: number;
  courtName: string;
  locationName: string;
  startTime: Date;
  endTime: Date;
  duration: number;
  sport: string;
  gameType: string;
  rankedMode: string;
  capacity: number;
  minLevel: number;
  maxLevel: number;
  createdAt: Date;
  expiresAt: Date;
  fulfilledAt?: Date;
}
